"use client";

import { Compass, Globe, Mountain, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Inclusions() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    icon: Compass,
    eyebrow: "01",
    titleStart: "Soutien ",
    titleAccent: "émotionnel",
    body: "Un espace d'écoute bienveillant pour déposer vos émotions, vos doutes et vos joies de jeune maman, sans jugement et en toute confidentialité.",
    link: "Découvrir le soutien"
  }, {
    icon: Globe,
    eyebrow: "02",
    titleStart: "Nutrition ",
    titleAccent: "postnatale",
    body: "Des repas sains, nourrissants et réconfortants, pensés pour favoriser votre récupération physique et votre énergie au quotidien.",
    link: "Voir le batch cooking"
  }, {
    icon: Mountain,
    eyebrow: "03",
    titleStart: "Village ",
    titleAccent: "maternel",
    body: "Rejoignez une communauté de femmes pour partager vos expériences, briser l'isolement et tisser des liens précieux durant cette transition.",
    link: "Rejoindre le village"
  }];
  return;
}